import { apiClient } from '@/lib/api-client';
import { QueueItem } from '@/models/queueItem';
import { useSnackbarStore } from '@certara/common-react-components';

// Response type for wrapped API responses
interface QueueApiResponse {
  IsSuccess?: boolean;
  Items?: QueueItem[];
}

class QueueService {
  async getQueues(companyId: number, allCompanies = false): Promise<QueueItem[]> {
    try {
      // API may return array directly or wrapped response
      const result = await apiClient.get<QueueItem[] | QueueApiResponse>(
        `/api/Main/GetQueues?companyId=${companyId}&allCompanies=${allCompanies}`
      );

      // Handle array response directly
      if (Array.isArray(result)) {
        return result;
      }

      // Handle wrapped response with IsSuccess (if backend uses this pattern)
      if (
        result &&
        'IsSuccess' in result &&
        result.IsSuccess &&
        Array.isArray(result.Items)
      ) {
        return result.Items;
      }

      // Unexpected data format - return empty array
      return [];
    } catch (error) {
      useSnackbarStore
        .getState()
        .addSnackbar(
          'Unable to load queue data.',
          'error',
          error instanceof Error ? error.message : String(error),
          true
        );
      // Don't throw error to prevent infinite retry loops
      return [];
    }
  }

  async updateCompletedOperations(
    companyId: number,
    items: QueueItem[]
  ): Promise<{ IsSuccess: boolean } | null> {
    return apiClient.post<{ IsSuccess: boolean }>('/api/Main/UpdateCompletedOperations', {
      companyId,
      items,
    });
  }
}

export const queueService = new QueueService();
